const isDate = (val: string | Date) => !isNaN(new Date(val).getTime());

export const formatTime = (date: string | Date) => {
  return isDate(date) ? new Date(date).toLocaleTimeString() : undefined;
};

export const formatDate = (date: string | Date = '') => {
  return isDate(date) ? new Date(date).toISOString() : undefined;
};
